export default "__VITE_ASSET__C8cLosKZ__"